var UploadThumbnailView = require('../thumbnail/upload');
var AppDecorate = require('../../../../app/decorate');
var ImagesFactory = require('../../../../factory/images');

module.exports = AppDecorate(require('./app/upload-list'), {
  uploadingThumbs: {},
  uploadAttempt: {},
  files: {},
  uploadConfig: {
    validation: {
      acceptFiles: 'image/*;capture=camera',
      allowedExtensions: [ 'jpg', 'jpeg', 'gif', 'png' ]
    },
    scaling: {
      includeExif: false,
      sendOriginal: false,
      sizes: [ {
        name: 'o',
        maxSize: INKIVE.C.VersionUploadSize['o']
      } ]
    }
  },

  initialize: function () {
    _.bindAll(this,
      'complete',
      'submittedEvent',
      'progressEvent',
      'errorEvent',
      'cancelEvent',
      'completeEvent',
      'getUploaderOptions'
    );

    this.debouncedMasonryReload = _.debounce(this.masonryReload, 800);
    this.addUploadThumbnail();
    this.initializeUpload();
  },

  addUploadThumbnail: function () {
    var $thumbnailWrapper = this.$el.find('.thumbnail-wrapper');
    this.$uploaderThumbnail = $('<div></div>').addClass('thumbnail uploader');

    $thumbnailWrapper.prependThumb(this.$uploaderThumbnail);
    this.views.uploadThumbnail = new UploadThumbnailView({
      el: this.$uploaderThumbnail
    });
  },

  getNewThumbnail: function () {
    var $newThumbnail = $('<div></div>').addClass('thumbnail uploading');

    $newThumbnail.insertAfter(this.$uploaderThumbnail);
    this.$uploaderThumbnail.parent().masonry('prepended', $newThumbnail);

    return new UploadThumbnailView({ el: $newThumbnail });
  },

  initializeUpload: function () {
    var $container = this.$el.find('.uploader.progress-button');

    $container.fineUploaderS3(this.getUploaderOptions($container))
      .on('submitted', this.submittedEvent)
      .on('progress', this.progressEvent)
      .on('error', this.errorEvent)
      .on('cancel', this.cancelEvent)
      .on('complete', this.completeEvent);
  },

  getUploaderOptions: function ($container) {
    var globalConfig = INKIVE.C.DEFAULT_FINEUPLOADER;
    var options = $.extend(true, {
      button: $container,
      objectProperties: { acl: 'public-read', key: getUploadKey }
    }, globalConfig, this.uploadConfig);

    return options;

    function getUploadKey (id) {
      var regEx = /(?:\.([^.]+))?$/;

      var name = $container.fineUploaderS3('getName', id);
      var udid = $container.fineUploaderS3('getUuid', id);
      var extension = regEx.exec(name)[1];
      var region = INKIVE.C.UPLOAD_SERVER.split('/').pop().split('.')[0];

      return region + '/original/' + udid + '.' + extension;
    }
  },

  submittedEvent: function (event, id, fileName) {
    var $container = $(event.currentTarget);

    this.views[id] = this.getNewThumbnail();
    this.views[id].toggleProgressBar(true);

    this.files[id] = $container.fineUploaderS3('getFile', id);
    this.views[id].on('thumbnail_load_error', _.bind(function () {
      this.errorEvent(null, id);
    }, this));

    this.views[id].on('cancel', _.bind(function () {
      var attempt = this.uploadAttempt[id];
      attempt && attempt.abort && attempt.abort();
      $container.fineUploaderS3('cancel', id);
    }, this));

    this.isFallbackUploadForced() && _.defer(_.bind(function () {
      $container.fineUploaderS3('cancel', id);
      this.regularUploadFallback(id);
    }, this));
  },

  progressEvent: function (event, id, fileName, uploadedBytes, totalBytes) {
    this.views[id] && this.views[id].updateProgressBar(uploadedBytes / totalBytes);
  },

  cancelEvent: function (event, id) {
    if (this.isFallbackUploadForced() && !this.uploadAttempt[id]) return;

    var view = this.views[id];
    this.tool.editor.canvas.call('advice.show', 'upload-cancel');
    this.clean(id);

    _.delay(_.bind(function () {
      view?.remove();
      this.debouncedMasonryReload();
    }, this), 1000);
  },

  errorEvent: function (event, id, skipFirstFail) {
    var view = this.views[id];
    var isFirstFail = !this.uploadAttempt[id] || event.type === 'complete';

    if (isFirstFail && !skipFirstFail) {
      (event && event.type) !== 'complete' && this.regularUploadFallback(id);
      return false;
    }

    INKIVE.Modal.alertMessage(INKIVE.TemplatesHelper('alert_default', {
      message: 'modal.alert.upload_image',
      try_again: true
    }));

    this.clean(id);
    _.delay(_.bind(function () {
      view && view.remove();
      this.debouncedMasonryReload();
    }, this), 1000);

    return true;
  },

  regularUploadFallback: function (id) {
    var file = this.files[id];
    var errorEvent = this.errorEvent;
    var onComplete = _.partial(this.complete, id);
    var $container = this.$el.find('.uploader.progress-button');

    this.uploadAttempt[id] = true;
    this.forceFallbackUpload();

    this.regularUploadFallbackUrl && onEndPoint.call(this);
    this.regularUploadFallbackUrl || $.get(
      BASE_URL + 'upload/getdirectuploadendpoint', _.bind(function (url) {
        this.regularUploadFallbackUrl = url;
        onEndPoint.call(this);
      }, this)
    );

    function onEndPoint () {
      var progressEvent = _.bind(this.progressEvent, this);
      var formData = new FormData();
      formData.append('userfile', file);
      formData.append('project_id', INKIVE.C.BOOK.id);

      this.uploadAttempt[id] = $.ajax({
        url: this.regularUploadFallbackUrl,
        type: 'POST',
        success: onSuccess,
        error: _.bind(function (event) { this.errorEvent(event, id); }, this),
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        dataType: 'json',
        xhr: function () {
          var myXhr = $.ajaxSettings.xhr();

          myXhr.upload && myXhr.upload.addEventListener('progress', function (event) {
            progressEvent(event, id, null, event.loaded, event.total);
          }, false);

          return myXhr;
        }
      });
    }

    function onSuccess (data) {
      if (!file) {
        return;
      }
      var key = data['key'];

      $.ajax({
        url: INKIVE.C.BASE_URL + 'upload/successasync',
        type: 'POST',
        dataType: 'json',
        success: onComplete,
        error: _.bind(function (event) { errorEvent(event, id); }, this),
        data: {
          type: 'editor',
          scrapbookId: INKIVE.C.BOOK.id,
          key: key,
          name: file.name,
          bucket: 'virginia.inkive.com'
        }
      });
    }
  },

  completeEvent: function (event, id, fileName, response, xhr) {
    var $container = $(event.currentTarget);

    if (response.success) {
      if (!response.name) {
        response.name = fileName;
      }
      this.complete(id, response);
    } else {
      this.errorEvent(event, id) && $container.fineUploaderS3('cancel', id);
    }
  },

  complete: function (id, data) {
    const thumb = ImagesFactory.getVersionUrl(data.tempLink, 'thumb');

    this.clean(id);
    this.views[id].setImage('photo-saved-' + data.photoId, thumb);
    this.views[id].on('resize', this.debouncedMasonryReload);
  },

  clean: function (id) {
    this.files = _.omit(this.files, id);
    this.uploadAttempt = _.omit(this.uploadAttempt, id);
  },

  forceFallbackUpload: function () {
    INKIVE.C.USE_FALLBACK_UPLOAD = 'FORCE';
  },

  isFallbackUploadForced: function () {
    return INKIVE.C.USE_FALLBACK_UPLOAD === 'FORCE';
  }
});
